export default __webpack_public_path__ + "static/media/available-app-store.f29cc7fa.png";